<div class="player-panel">
    <profile-image [image]="player().image"/>
    <div class="player-info">
        <div class='player-name'>{{player().name}}</div>
        <div [hidden]="!player().tee?.name">{{player().tee?.name}} tees</div>
        <div [hidden]="!player().playingHandicap">Handicap {{player().playingHandicap}}</div>
    </div>
    <div class="flex-spacer"></div>
    <div *ngFor="let total of totals(); trackBy: trackByMethod">
        <total-score [total]="total"/>
    </div>
</div>

